// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ElementsHeading: MarkdocTagRegistration = {
  tag: 'elements-heading',
  component: 'ElementsHeading',
};
